import { AUTH_BASE_URL } from "../../../envs";
import { HttpClient } from "../http-client";
import { TokenManager } from "../token-manager";

export interface AuthTokenPair {
  accessToken: string
  refreshToken: string
}

export class AuthClient {

  private readonly httpClient
  private readonly tokenManager

  constructor(httpClient: HttpClient, tokenManager: TokenManager) {
    this.httpClient = httpClient
    this.tokenManager = tokenManager
  }

  async initiate(username: string): Promise<{ message: string, methods: string[] }> {
    const response = await this.httpClient.fetch(`${AUTH_BASE_URL}/login/initiate`, {
      method: 'POST',
      body: JSON.stringify({
        username
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error(`Login initialization failed with status ${response.status}`)
    }
    return await response.json()
  }

  async generateOtp(username: string): Promise<void> {
    const response = await this.httpClient.fetch(`${AUTH_BASE_URL}/otp`, {
      method: 'POST',
      body: JSON.stringify({
        username
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error(`Login failed with status ${response.status}`)
    }
    return await response.json()
  }

  async loginByPassword(username: string, password: string): Promise<void> {
    const response = await this.httpClient.fetch(`${AUTH_BASE_URL}/login`, {
      method: 'POST',
      body: JSON.stringify({
        username,
        password
      }),
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include'
    })
    if (!response.ok) {
      throw new Error(`Login failed with status ${response.status}`)
    }
    const res = await response.json() as AuthTokenPair
    this.tokenManager.setToken(res.accessToken)
  }
  async loginByOtp(username: string, otp: string): Promise<void> {
    const response = await this.httpClient.fetch(`${AUTH_BASE_URL}/login`, {
      method: 'POST',
      body: JSON.stringify({
        username,
        otp
      }),
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include'
    })
    if (!response.ok) {
      throw new Error(`Login failed with status ${response.status}`)
    }
    const res = await response.json() as AuthTokenPair
    this.tokenManager.setToken(res.accessToken)
  }
  async logout(): Promise<void> {
    const response = await this.httpClient.fetch(`${AUTH_BASE_URL}/logout`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include'
    })
    if (!response.ok) {
      throw new Error(`Logout failed with status ${response.status}`)
    }
    this.tokenManager.setToken(null)
  }

  async recover(username: string): Promise<void> {
    const response = await this.httpClient.fetch(`${AUTH_BASE_URL}/recover`, {
      method: 'POST',
      body: JSON.stringify({
        username
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error(`Login failed with status ${response.status}`)
    }
    return await response.json()
  }

  async test(): Promise<void> {
    const response = await this.httpClient.fetch(`${AUTH_BASE_URL}/protected`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error(`Login failed with status ${response.status}`)
    }
    return await response.json()
  }
}
